import { Suspense, lazy } from 'react';

const MarkdownContentInner = lazy(() => import('./MarkdownContentInner'));

export const MarkdownContent = ({ children }: { children: string }) => (
  <Suspense fallback={null}>
    <MarkdownContentInner>{children}</MarkdownContentInner>
  </Suspense>
);
